export default "__VITE_ASSET__61eb53c7__"